'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSearchForOption;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _searchValueIcon = require('../icons/searchValueIcon');

var _searchValueIcon2 = _interopRequireDefault(_searchValueIcon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getSearchForOption(searchValue) {
  return {
    label: _react2.default.createElement('span', {
      className: 'rainbow-google-address-lookup_search-option-label'
    }, 'Search for:', _react2.default.createElement('span', {
      className: 'rainbow-google-address-lookup_search-option-typing'
    }, "\u2018", searchValue, "\u2019")),
    data: searchValue,
    icon: _react2.default.createElement(_searchValueIcon2.default, null)
  };
}